/* global BX, bitrix_sessid, FormUtils */

(function () {
    if (typeof BX === 'undefined' || typeof FormUtils === 'undefined') return;

    const modalId = 'report-error-modal-overlay';
    const closeBtnId = 'report-error-form-header-btn';
    const submitBtn = document.getElementById('report-error-submit-btn');
    const commonErrorsBlock = document.getElementById('report-form-common-errors');
    const captchaContainerId = 'captcha-container-report';
    const containerSelector = '';

    const email = document.getElementById('email-report');
    const message = document.getElementById('message-report');
    const productName = document.getElementById('productName');

    if (!document.getElementById(modalId) || !submitBtn) return;

    const initCaptcha = () => FormUtils.initCaptcha(captchaContainerId);
    const resetCaptcha = () => FormUtils.resetCaptcha();

    const clearFields = () => {
        email.value = '';
        message.value = '';
    };

    const hideErrors = () => {
        FormUtils.clearFieldErrors(containerSelector);
        FormUtils.hideCommonError(commonErrorsBlock);
    };

    const validate = () => {
        let isValid = true;
        hideErrors();

        if (!FormUtils.validateRequired(email.value)) {
            FormUtils.showFieldError(email, '*Обязательное поле');
            isValid = false;
        } else if (!FormUtils.validateEmail(email.value)) {
            FormUtils.showFieldError(email, '*Введите корректный E-mail');
            isValid = false;
        }

        if (!FormUtils.validateRequired(message.value)) {
            FormUtils.showFieldError(message, '*Обязательное поле');
            isValid = false;
        }

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        if (!captchaToken || !captchaToken.value) {
            FormUtils.showCommonError(commonErrorsBlock, 'Пожалуйста, подтвердите, что вы не робот');
            isValid = false;
        }

        if (!isValid) FormUtils.scrollToFirstError(containerSelector, commonErrorsBlock);
        return isValid;
    };

    const send = async () => {
        if (!validate()) return;

        const captchaToken = document.querySelector(`#${captchaContainerId} input[name="smart-token"]`);
        const token =
            typeof bitrix_sessid === 'function' ? bitrix_sessid() : BX.bitrix_sessid ? BX.bitrix_sessid() : '';

        const payload = {
            email: email.value,
            message: message.value,
            smart_token: captchaToken ? captchaToken.value : '',
            productUrl: window.location.href,
            productName: productName.value,
        };

        if (submitBtn) submitBtn.disabled = true;

        try {
            await FormUtils.sendFormData({
                url: '/api/v1/form/catalog-report',
                payload,
                headers: {
                    'Session-Id': token,
                    'X-Requested-With': 'XMLHttpRequest',
                },
                submitBtn,
                commonErrorsBlock,
                containerSelector,
                onSuccess: (result) => {
                    alert(result.message || 'Спасибо! Ваше сообщение отправлено.');
                    close();
                },
                onFieldError: (field, msg) => {
                    const el = document.getElementById(field);
                    if (el) FormUtils.showFieldError(el, msg);
                },
            });
        } finally {
            if (submitBtn) submitBtn.disabled = false;
        }
    };

    const open = () => {
        document.getElementById(modalId).style.display = 'flex';
        document.body.style.overflow = 'hidden';
        hideErrors();
        initCaptcha();
        resetCaptcha();
    };

    const close = () => {
        document.getElementById(modalId).style.display = 'none';
        document.body.style.overflow = '';
        clearFields();
        hideErrors();
        resetCaptcha();
    };

    FormUtils.createModal({
        modalId,
        closeBtnId,
        openBtnClass: '.open-report-error',
        onOpen: open,
        onClose: close,
    });

    submitBtn.addEventListener('click', send);
})();
